import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
  errors: null,
  user: null,
  token:"",
  isAuthenticated: !!JwtService.getToken()
};

const getters = {
  currentUser(state) {
    // console.log(state.user)
    return state.user||JwtService.getUser();
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  token(state) {
    // console.log(state)
    return state.token||JwtService.getToken();
  }
};

const actions = {
  [LOGIN](context, credentials) {
    return new Promise(resolve => {
      console.log(credentials)
      // ApiService.post("login", credentials)
      //   .then(({ data }) => {
          context.commit(SET_AUTH, credentials.data);
          resolve(credentials);
      //   })
      //   .catch(({ response }) => {
      //     context.commit(SET_ERROR, response.data.errors);
      //   });
    });
  },
  [LOGOUT](context) {
    console.log(context)
    context.commit(PURGE_AUTH);
  },
  [REGISTER](context, credentials) {
    return new Promise((resolve, reject) => {
      // ApiService.post("users", { user: credentials })
      //   .then(({ data }) => {
      //     context.commit(SET_AUTH, data);
      //     resolve(data);
      //   })
      //   .catch(({ response }) => {
      //     context.commit(SET_ERROR, response.data.errors);
      //     reject(response);
      //   });
    });
  },
  [VERIFY_AUTH](context) {
    if (JwtService.getToken()) {
      // ApiService.setHeader();
      // ApiService.get("verify")
      //   .then(({ data }) => {
      //     context.commit(SET_AUTH, data);
      //   })
      //   .catch(({ response }) => {
      //     context.commit(SET_ERROR, response.data.errors);
      //   });
    } else {
      context.commit(PURGE_AUTH);
    }
  },
  [UPDATE_USER](context, payload) {
    const { email, username, password, image, bio } = payload;
    const user = { email, username, bio, image };
    if (password) {
      user.password = password;
    }

    // return ApiService.put("user", user).then(({ data }) => {
    //   context.commit(SET_AUTH, data);
    //   return data;
    // });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, user) {
    console.log(state)
    state.isAuthenticated = true;
    state.user = user;
    state.errors = {};
    state.token = state.user.token;
    JwtService.saveToken(state.user.token);
    JwtService.saveUser(state.user);
  },
  [PURGE_AUTH](state) {
    state.isAuthenticated = false;
    state.user = {};
    state.errors = {};
    JwtService.destroyToken();
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
